export const environment = {
    production: true,
    apiUrl: 'https://pidb.ppa.com.ph'
};



// WEBPACK FOOTER //
// ./Angular/environments/environment.ts